import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { TagDropdownSelectorComponent } from './components/tag-dropdown-selector/tag-dropdown-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { BaseSelectorModule } from '../base-selector/base-selector.module';
import { TagListSelectorComponent } from './components/tag-list-selector/tag-list-selector.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MatPaginatorModule } from '@angular/material/paginator';

export { TagDropdownSelectorComponent } from './components/tag-dropdown-selector/tag-dropdown-selector.component';

@NgModule({
  declarations: [TagDropdownSelectorComponent, TagListSelectorComponent],
  imports: [
    CoreModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    MatPaginatorModule,
    BaseSelectorModule,
    InfiniteScrollDirective,
  ],
  exports: [TagDropdownSelectorComponent, TagListSelectorComponent],
})
export class TagSelectorModule {}
